import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { affiliations } from '../../helpers/analytics-utils/constants';
import makeUniqueProductId from '../../helpers/make-unique-product-id';
import { discountedPriceRange, priceRange } from '../../helpers/price-ranges';
import makeProductBaseProperties from '../event-transformation/product-common';
function makeProductListProperties(products, currency) {
  const productProperties = products.map(product => _objectSpread(_objectSpread({}, makeProductBaseProperties(product)), {}, {
    currency
  }));
  return productProperties;
}
export function transformLegacyProductListViewed(data) {
  const cartAffiliation = data.ecommerce.affiliation;
  const currency = data.ecommerce.currencyCode;
  const productProperties = makeProductListProperties(data.ecommerce.detail.products, currency);
  const eventProperties = {
    category: 'Ecommerce',
    label: 'product_list_viewed',
    list_id: data.ecommerce.listId,
    cart_affiliation: cartAffiliation,
    sort_method: data.ecommerce.sortMethod,
    products: productProperties
  };
  return {
    method: 'track',
    parameters: ['Product List Viewed', eventProperties]
  };
}
const isSGPageTemplateProduct = product => {
  const typename = product.__typename;
  return typename && typename === 'SGPageTemplateProduct';
};
export function makeAnalyticsProductListViewedEventData(products) {
  let listId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Product List';
  let sortMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return {
    event: 'product_list_viewed',
    ecommerce: {
      currencyCode: 'AUD',
      affiliation: affiliations.WESTFIELD_DIRECT_AU,
      listId,
      sortMethod,
      detail: {
        products: products.map(product => {
          if (isSGPageTemplateProduct(product)) {
            var _product$promotions, _product$shop$retaile;
            const price = parseFloat((product.discountedPrice || product.price || '$0').split('-').map(s => s.trim())[0].replace('$', ''));
            const merchandisedPromotion = (_product$promotions = product.promotions) === null || _product$promotions === void 0 ? void 0 : _product$promotions[0];
            return _objectSpread(_objectSpread({
              name: product.title,
              category: 'Ecommerce',
              id: product.variantGroupCode,
              variant: undefined,
              uniqueId: makeUniqueProductId(product.variantGroupCode, product.shop.id),
              price,
              brand: product.brand,
              dimension127: product.shop.name,
              dimension128: (_product$shop$retaile = product.shop.retailer) === null || _product$shop$retaile === void 0 ? void 0 : _product$shop$retaile.sys.id,
              dimension129: 'AUD'
            }, merchandisedPromotion && {
              dimension131: merchandisedPromotion.campaignId,
              dimension132: merchandisedPromotion.title
            }), {}, {
              dimension136: product.variantGroupCode,
              dimension138: product.shop.id
            });
          } else {
            var _discountedPriceRange, _product$variant, _product$variant2, _product$brand, _product$shop$retaile2, _product$variant3;
            const productPriceRange = (_discountedPriceRange = discountedPriceRange(product)) !== null && _discountedPriceRange !== void 0 ? _discountedPriceRange : priceRange(product);
            const price = productPriceRange === null || productPriceRange === void 0 ? void 0 : productPriceRange.min;
            const merchandisedPromotion = (_product$variant = product.variant) === null || _product$variant === void 0 || (_product$variant = _product$variant.promotions) === null || _product$variant === void 0 ? void 0 : _product$variant[0];
            return _objectSpread(_objectSpread({
              name: product.name,
              category: 'Ecommerce',
              id: product.variantGroupCode,
              uniqueId: makeUniqueProductId(product.variantGroupCode, product.shop.id, (_product$variant2 = product.variant) === null || _product$variant2 === void 0 ? void 0 : _product$variant2.sku),
              price,
              brand: (_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name,
              variant: undefined,
              dimension127: product.shop.name,
              dimension128: (_product$shop$retaile2 = product.shop.retailer) === null || _product$shop$retaile2 === void 0 ? void 0 : _product$shop$retaile2.sys.id,
              dimension129: 'AUD'
            }, merchandisedPromotion && {
              dimension131: merchandisedPromotion.campaignId,
              dimension132: merchandisedPromotion.title
            }), {}, {
              dimension136: product.variantGroupCode,
              dimension137: (_product$variant3 = product.variant) === null || _product$variant3 === void 0 ? void 0 : _product$variant3.sku,
              dimension138: product.shop.id
            });
          }
        })
      }
    }
  };
}